module.exports = __webpack_public_path__ + "img/img98.3784676a.jpg";